'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Big from 'UIComponents/elements/Big';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { EmailValidationStates, EmailValidationStateNames } from 'ExportDialog/Constants';

function createValueExtractor(onChangeCallback) {
  return event => {
    onChangeCallback(event.target.value);
  };
}

const stateToLang = {
  [EmailValidationStates.VALID]: null,
  [EmailValidationStates.INVALID]: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "exportDialog.emailErrors.invalidEmail"
  })
};

const isSend = preference => {
  return preference === 'SEND';
};

const isEmailNotValid = validationState => {
  return validationState !== EmailValidationStates.VALID;
};

const getNotificationText = (email, notification, value) => {
  if (email && notification) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "exportDialog.preference.exportToBothText",
      options: {
        value
      }
    });
  } else if (email) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "exportDialog.preference.exportToEmailText",
      options: {
        value
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "exportDialog.preference.exportToNotificationCenterText"
    });
  }
};

const EmailField = ({
  onChange,
  validationState,
  value,
  preferences
}) => {
  if (isEmailNotValid(validationState, value)) {
    return /*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.emailLabel"
      }),
      help: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.emailDescription"
      }),
      error: validationState !== EmailValidationStates.VALID,
      validationMessage: stateToLang[validationState],
      className: "m-bottom-6",
      children: /*#__PURE__*/_jsx(UITextInput, {
        value: value,
        onChange: createValueExtractor(onChange)
      })
    });
  }

  return /*#__PURE__*/_jsx(Big, {
    className: "m-bottom-6",
    tagName: "p",
    children: getNotificationText(isSend(preferences.EMAIL), isSend(preferences.NOTIFICATION_SIDEBAR), value)
  });
};

EmailField.propTypes = {
  onChange: PropTypes.func.isRequired,
  validationState: PropTypes.oneOf(EmailValidationStateNames).isRequired,
  value: PropTypes.string.isRequired,
  preferences: PropTypes.object
};
export default EmailField;